import { useState, useEffect } from "react";
import { ModalBodylHistorial } from "../historial-solicitudes/modalHistorial/modalHistorial";
import { faHistory, faFolderOpen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSolicitudesCurso } from "./useSolicitudesCurso";
import { Timeline } from "../../components/ui/Timeline";
import { formatFecha } from "../../utils/funciones";
import { useLocation } from "react-router-dom";
import { modalEjecutar } from "../../components/ui/sweetAlerts";
import PropTypes from "prop-types";
import { useHistorialSolicitudes } from "../historial-solicitudes/useHistorialSolicitudes";
import { useSolicitudesAdministrador } from "../solicitudes-administrador/useSolicitudesAdministrador";
import Spinner from "../../components/ui/Spinner";

const DatosContractualesAdmin = ({ obj, visibleBtns, visibleBotones, documentos, verHistorial }) => {
  const { verPermiso, puedeEliminar, eliminarSolicitudInicial } = useSolicitudesAdministrador();
  const { returnTipoContrato } = useSolicitudesCurso();
  const [cargando, setCargando] = useState(true);

  const LabelVal = ({ label, val }) => (
    <div className="mb-1 px-2">
      <div className="text-uppercase fw-bold" style={{ fontSize: "0.72rem", letterSpacing: "0.5px", color: "#495057" }}>
        {label}
      </div>
      <div className="text-dark" style={{ fontSize: "0.95rem", fontWeight: "500" }}>
        {val}
      </div>
    </div>
  );

  const SectionTitle = ({ title }) => (
    <div className="mb-2 pb-1" style={{ borderBottom: "2px solid #14406e" }}>
      <h6 className="fw-bold m-0" style={{ color: "#14406e" }}>
        {title}
      </h6>
    </div>
  );

  useEffect(() => {
    if ([true, false].includes(puedeEliminar)) {
      setCargando(false);
    }
  }, [puedeEliminar]);

  useEffect(() => {
    verPermiso(obj.id);
  }, []);

  return (
    <>
      {obj ? (
        <div className="pb-2 cuerpoModalData d-flex flex-column gap-2 px-2">
          <div>
            <SectionTitle title="Datos del colaborador" />
            <div className="row" style={{ rowGap: "7px" }}>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Nro personal" val={obj.persona.id_sap || "No posee id SAP"} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Colaborador" val={`${obj.persona.nombre} ${obj.persona.apellido_pat} ${obj.persona.apellido_mat}`} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="RUT" val={obj.persona.identificacion} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Estatus contrato" val={returnTipoContrato(obj.persona.tipo_contrato)} />
              </div>
            </div>
          </div>

          <div>
            <SectionTitle title="Datos asociados a SAP" />
            <div className="row" style={{ rowGap: "7px" }}>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Instalación actual" val={obj.instalacion_actual || "---"} />
              </div>
              {[3].includes(obj.id_tipo_solicitud) && (
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Instalación a traspasar" val={obj.nombre_instalacion_destino} />
                </div>
              )}
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Cargo actual" val={obj.nombre_cargo_actual.split("|")[1]} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="Cargo solicitado" val={obj.nombre_nuevo_cargo ? obj.nombre_nuevo_cargo : "---"} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="PHTD actual" val={obj.nombre_cargo_actual.split("|")[0]} />
              </div>
              <div className="col-6 col-md-6 col-lg-3">
                <LabelVal label="PHTD solicitado" val={obj.nuevo_plan_horario.split("|")[0] ? obj.nuevo_plan_horario.split("|")[0] : "---"} />
              </div>
            </div>
          </div>

          {![3, 4, 5].includes(obj.id_tipo_solicitud) && (
            <div>
              <SectionTitle title="Datos asociados a temporis" />
              <div className="row" style={{ rowGap: "7px" }}>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Unidad solicitada" val={obj.descripcion_unidad_temporis.split(" - ")[0]} />
                </div>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Cargo" val={obj.descripcion_unidad_temporis.split(" - ")[1]} />
                </div>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Plan horario" val={obj.nuevo_plan_horario.split("|")[1]} />
                </div>
              </div>
            </div>
          )}

          {[4].includes(obj.id_tipo_solicitud) && (
            <div>
              <SectionTitle title="Datos complementarios" />
              <div className="row" style={{ rowGap: "7px" }}>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Estatus contrato" val={obj.tipo_cambio_contrato === 1 ? "Cambiar a indefinido" : obj.tipo_cambio_contrato === 2 ? "Renovar plazo fijo" : ""} />
                </div>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Fecha limite renovación" val={obj.tipo_cambio_contrato === 1 ? "31-12-9999" : obj.tipo_cambio_contrato === 2 ? formatFecha(obj.fecha_renovacion_contrato.replace(/-/g, "")) : ""} />
                </div>
              </div>
            </div>
          )}

          {[5].includes(obj.id_tipo_solicitud) && (
            <div>
              <SectionTitle title="Baja del colaborador" />
              <div className="row" style={{ rowGap: "7px" }}>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Fecha solicitud de baja" val={formatFecha(obj.fecha_inicio_cambio.replaceAll("-", ""))} />
                </div>
                <div className="col-6 col-md-6 col-lg-3">
                  <LabelVal label="Causal invocada" val={obj.clausula_despido?.nombre || "No especifíca"} />
                </div>
                <div className="col-12 col-md-12 col-lg-3" title={obj.motivo_desvinculacion}>
                  <LabelVal label="Motivo desvinculación" val={obj.motivo_desvinculacion} />
                </div>
              </div>
            </div>
          )}

          {![5].includes(obj.id_tipo_solicitud) && (
            <div>
              <SectionTitle title="Fecha efectiva del cambio" />
              <div className="row">
                <div className="col-12">
                  <LabelVal label="Fecha efectiva del cambio" val={formatFecha(obj.fecha_inicio_cambio.replaceAll("-", ""))} />
                </div>
              </div>
            </div>
          )}

          <div>
            <SectionTitle title="Documentos adjuntos" />
            <div className="d-flex flex-wrap gap-2 mt-1">
              {documentos.length > 0 ? (
                documentos.map((el, idx) => (
                  <a key={el.key_documento.split("/")[2].replaceAll(" ", "")} target="_blank" href={el.url} className="badge text-dark text-decoration-none px-3 py-2 fs-6 rounded-pill" style={{ backgroundColor: "#b8d1ea" }}>
                    {el.key_documento.split("/")[2]}
                  </a>
                ))
              ) : (
                <div className="d-flex align-items-center gap-2 text-muted px-3 py-2 bg-light rounded" style={{ border: "1px dashed #dee2e6" }}>
                  <FontAwesomeIcon icon={faFolderOpen} /> Sin documentos adjuntos
                </div>
              )}
            </div>
          </div>

          <div className="mt-4 pt-3" style={{ borderTop: "1px solid #dee2e6" }}>
            <div className={`d-flex gap-3 justify-content-end align-items-center w-100`}>
              {cargando ? (
                <div style={{ width: "134px" }}>
                  <Spinner clases="my-1" />
                </div>
              ) : (
                <>
                  {puedeEliminar && (
                    <button
                      className="btn btn-danger px-4 py-2 fw-bold rounded-pill d-flex align-items-center shadow-sm transition-all"
                      style={{ border: "1px solid #cce0f0" }}
                      title="Ver historial"
                      onClick={() => {
                        modalEjecutar(eliminarSolicitudInicial, "¿Está seguro de eliminar la solicitud?, Esta acción no se puede deshacer", obj.id);
                      }}
                    >
                      <span className="me-2">Eliminar</span> <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                  )}
                </>
              )}
              <button className="btn btn-light px-4 py-2 fw-bold rounded-pill d-flex align-items-center shadow-sm transition-all" style={{ color: "#2a77b9", border: "1px solid #cce0f0" }} title="Ver historial" onClick={verHistorial}>
                <span className="me-2">Historial</span> <FontAwesomeIcon icon={faHistory} />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center p-5 text-muted">No hay información disponible</div>
      )}
    </>
  );
};

export const ModalBodyAdmin = ({ obj, visibleBtns }) => {
  const [visibleBotones, setVisibleBotones] = useState(false);
  const { returnAccesos, visibleHistorial, idSolicitud, setVisibleHistorial, traerDocumentos, documentos, setIdSolicitud } = useSolicitudesCurso();
  const { traerHistorial, historial } = useHistorialSolicitudes();
  const location = useLocation();

  const validarBotones = path => {
    if (path === "/solicitudes-traspaso") {
      setVisibleBotones(visibleBtns);
    } else {
      const resp = returnAccesos(localStorage.getItem("id_perfil"), obj.id_tipo_solicitud, obj.id_estado_solicitud);
      setVisibleBotones(resp);
    }
  };

  useEffect(() => {
    traerDocumentos(obj);
    validarBotones(location.pathname);
  }, []);

  return (
    <>
      {visibleHistorial ? (
        <Timeline
          id={idSolicitud}
          volver={() => {
            setVisibleHistorial(false);
          }}
        />
      ) : (
        <DatosContractualesAdmin
          obj={obj}
          visibleBtns={visibleBtns}
          visibleBotones={visibleBotones}
          documentos={documentos}
          verHistorial={() => {
            setIdSolicitud(obj.id);
            setVisibleHistorial(true);
          }}
        />
      )}
    </>
  );
};

ModalBodyAdmin.propTypes = {
  obj: PropTypes.object.isRequired,
  visibleBtns: PropTypes.bool,
};

DatosContractualesAdmin.propTypes = {
  obj: PropTypes.object.isRequired,
  visibleBtns: PropTypes.bool,
  visibleBotones: PropTypes.bool,
  documentos: PropTypes.array,
  verHistorial: PropTypes.func.isRequired,
};
